// extracted by mini-css-extract-plugin
export default {"local":"local--JvhpI","visible":"visible--cJX_h"};